import { gql } from 'graphql-tag';

// W-9 queries (w9-plan §3.1, §6.6). Operation names are what
// refetchQueries refers to.

export const GET_W9_YEARS = gql`
  query GetW9Years($form_id: Int!) {
    getW9Years(form_id: $form_id) {
      year
      count
      status
    }
  }
`;

export const GET_W9_STATS = gql`
  query GetW9Stats($form_id: Int!, $tax_year: Int!) {
    getW9Stats(form_id: $form_id, tax_year: $tax_year) {
      on_file
      this_month
      new_this_week
      not_back
      businesses
      individuals
      by_month
      latest_submitted_at
      latest_submitter_name
    }
  }
`;

export const GET_FORM_SUBMISSION_EVENTS = gql`
  query GetFormSubmissionEvents($submission_id: Int!) {
    getFormSubmissionEvents(submission_id: $submission_id) {
      id
      kind
      user_name
      meta
      created_at
    }
  }
`;

// The official W-9 PDF for one entry: a short-lived signed link.
export const GET_W9_PDF = gql`
  query GetW9Pdf($submission_id: Int!) {
    getW9Pdf(submission_id: $submission_id) {
      url
      filename
      expires_at
    }
  }
`;
